/* stylelint-disable selector-no-vendor-prefix */

/**
    @prop --uic-input-field-height: The height of the input
    @prop --uic-input-field-min-width: The minimum width of the input
*/

uic-input-field {
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    padding: 8px;
    min-width: var(--uic-input-field-min-width);
}

.uic-input-field[variant-value],
.uic-input-field--unit {
    .uic-input-field__input {
        text-align: right;
    }

    .uic-input-field__flag {
        left: 4px;
        right: unset;
    }

    &.uic-input-field--invalid,
    &.uic-input-field--flag {
        .uic-input-field__input {
            padding-left: 48px;
            padding-right: 8px;
        }
    }
}

.uic-input-field--focused {
    .uic-input-field__input-wrapper {
        outline-offset: -2px;
        outline: 2px solid var(--uic-color-blue2);
        color: var(--uic-color-black);
    }
}

.uic-input-field--flag,
.uic-input-field--invalid {
    .uic-input-field__flag {
        display: block;
    }
}

.uic-input-field--invalid {
    .uic-input-field__input {
        padding-right: 48px;
    }

    .uic-input-field__helper-text {
        color: var(--uic-color-red1);
    }
}

.uic-input-field.uic-input-field--has-label {
    padding: 2px 8px 8px;

    .uic-input-field__label {
        display: block;
        padding-bottom: 4px;
    }
}

.uic-input-field.uic-input-field--has-helper-text {
    padding-bottom: 1px;

    .uic-input-field__helper-text {
        margin-top: 3px;
    }
}

.uic-input-field[disabled] .uic-input-field__input-wrapper {
    border: 1px solid var(--uic-color-grey2a25);
}

.uic-input-field__input-wrapper {
    position: relative;
    display: flex;
    box-sizing: border-box;
    border: 1px solid var(--uic-color-grey2);
    background: var(--uic-color-white);

    &:hover {
        border-color: var(--uic-color-blue2);
        color: var(--uic-color-blue3);
    }

    &:active {
        border: 1px solid var(--uic-color-blue2);
        color: var(--uic-color-blue3);
        background: var(--uic-color-blue2a10);
    }
}

.uic-input-field__label {
    overflow: hidden;
    color: var(--uic-color-black);
    font-size: var(--uic-font-size-normal);
    line-height: var(--uic-line-height-normal);
    text-overflow: ellipsis;
}

.uic-input-field__input {
    @include font(medium, semibold);
    text-overflow: ellipsis;
    box-sizing: border-box;
    height: 100%;
    min-width: 0;
    flex: 1 1 auto;
    background: transparent;
    border: 0;
    border-radius: 0;
    padding: 8px;
    outline: none;
    color: inherit;
    caret-color: var(--uic-color-blue2);

    &::placeholder {
        color: var(--uic-color-grey3a50);
        font-weight: normal;
    }

    &::selection {
        background-color: var(--uic-color-blue2);
        color: var(--uic-color-white);
        line-height: 24px;
    }

    &::-moz-selection {
        background-color: var(--uic-color-blue2);
        color: var(--uic-color-white);
    }

    &:disabled::selection {
        background-color: transparent;
        color: inherit;
    }
}

.uic-input-field__flag {
    display: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: var(--uic-icon-width);
    height: var(--uic-icon-width);
    right: 4px;

    svg {
        width: 100%;
        height: 100%;
    }
}

.uic-input-field__clear-button {
    --uic-icon-width: var(--uic-icon-dimensions-default);
    --uic-icon-height: var(--uic-icon-dimensions-default);
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    right: 8px;
    background: none;
    padding: 0;
    margin: 0;
    border: 0;
    outline: 0;
    color: var(--uic-icon-button-color);
    width: var(--uic-icon-dimensions-default);
    height: var(--uic-icon-dimensions-default);
    cursor: pointer;
}

.uic-input-field__unit {
    @include font(normal, semibold);
    box-sizing: border-box;
    position: relative;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    color: var(--uic-color-black);

    &::before {
        content: "";
        position: absolute;
        width: 1px;
        left: 0;
        top: 7px;
        bottom: 7px;
        background: var(--uic-color-grey2);
    }
}

.uic-input-field__helper-text {
    overflow: hidden;
    color: var(--uic-color-black);
    font-size: 0.8rem;
    line-height: 1.3rem;
    text-overflow: ellipsis;

    &-inner {
        @include truncate();
    }
}

uic-input-field[disabled] {
    pointer-events: none;

    .uic-input-field {
        &__input {
            border-color: var(--uic-color-grey2a25);
            color: var(--uic-color-grey3a50);
            background: var(--uic-color-white);
            font-weight: var(--uic-font-weight-normal);
        }

        &__unit {
            color: var(--uic-color-grey3a50);
        }
    }
}

@media #{$breakpoint_tablet} {
    .uic-input-field__input-wrapper {
        height: 40px;
    }
}

@media #{$breakpoint_desktop} {
    .uic-input-field__input-wrapper {
        height: 48px;
    }
}

@media #{$breakpoint_tablet_small} {
    .uic-input-field__input-wrapper {
        height: 30px;
    }
}
